/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RwrDeploymentWithNullEdrRegion } from './rwrDeploymentWithNullEdrRegion';


export interface MigratedRwrDeploymentSummary { 
    total_byol_deployments_with_null_edr_regions?: number;
    successfully_updated?: number;
    failed_to_updated?: number;
    failed_deployment_details?: Array<RwrDeploymentWithNullEdrRegion>;
}

